import React, { FC, ReactElement, useCallback } from 'react'
import { Button } from '@chakra-ui/react'
import { ButtonProps } from '@chakra-ui/button'

interface ISectionListItemTriggerButtonProps extends ButtonProps {
  isExpanded: boolean
  expandText: string
  collapseText: string
  isDisabled?: boolean
  rightIcon?: ReactElement
  leftIcon?: ReactElement
  onExpandClick?: () => void
  onCollapseClick?: () => void
}

export const SectionListItemTriggerButton: FC<ISectionListItemTriggerButtonProps> = ({
  collapseText,
  expandText,
  isDisabled,
  isExpanded,
  leftIcon,
  onCollapseClick,
  onExpandClick,
  rightIcon,
  ...rest
}) => {
  const handleClick = useCallback(
    () => (isExpanded ? onCollapseClick?.() : onExpandClick?.()),
    [onCollapseClick, onExpandClick, isExpanded],
  )

  return (
    <Button
      _disabled={{ color: 'inherit', cursor: 'not-allowed' }}
      _hover={{ backgroundColor: 'inherit' }}
      fontSize="md"
      isDisabled={isDisabled}
      leftIcon={leftIcon}
      onClick={handleClick}
      rightIcon={rightIcon}
      size="sm"
      textAlign="end"
      variant="tertiary"
      width="full"
      {...rest}>
      {isExpanded ? collapseText : expandText}
    </Button>
  )
}
